import React from 'react';
import { Router, Route, IndexRoute, browserHistory } from 'react-router';
import App from './components/App';
import HomePage from './components/HomePage';
import About from './components/about/About';
import Portfolio from './components/portfolio/Portfolio';
import Cookies from './components/about/Cookies';
import AppGallery from './components/AppGallery';

export default (
  <Router history={browserHistory}>
    <Route path="/" component={App}>
      <IndexRoute component={HomePage} />
      <Route path="about" component={About} />
      <Route path="/cookies" component={Cookies} />
    </Route>
    <Route path="/" component={AppGallery}>
      <Route path="/portfolio" component={Portfolio} />
    </Route>
  </Router>
);



// WEBPACK FOOTER //
// ./src/routes.js